import { render } from "./tab-consent.vue?vue&type=template&id=c8eedf76&scoped=true"
import script from "./tab-consent.vue?vue&type=script&lang=js"
export * from "./tab-consent.vue?vue&type=script&lang=js"

import "./tab-consent.vue?vue&type=style&index=0&id=c8eedf76&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8eedf76"]])

export default __exports__